import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { Link } from "react-router-dom";
import Table from "../../../../core/common/dataTable";
import { all_routes } from "../../../router/all_routes";
import { getAllModesOfCourse } from "../../../../core/data/redux/modesOfCourseSlice";

type AppDispatch = ThunkDispatch<any, any, AnyAction>;

export interface IModeOfCourse {
  id: number;
  course_mode_id: string;
  course_mode_title: string;
  created_at: string;
  modified_at: string;
}

interface Pagination {
  current: number;
  pageSize: number;
  total: number;
}

interface SearchParams {
  query: string;
}

const ModesOfCourseMaster = () => {
  const dispatch = useDispatch<AppDispatch>();
  const modesOfCourseState = useSelector((state: any) => state.modesOfCourseState);
  const routes = all_routes;

  const [dataList, setDataList] = useState<IModeOfCourse[]>([]);
  const [searchParams, setSearchParams] = useState<SearchParams>({ query: "" });
  const [pagination, setPagination] = useState<Pagination>({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchRecords = useCallback(
    (searchParams: SearchParams, page: number, pageSize: number) => {
      dispatch(getAllModesOfCourse({ query: searchParams.query, page, limit: pageSize }));
    },
    [dispatch]
  );

  useEffect(() => {
    const delay = setTimeout(() => {
      setPagination((prev) => ({ ...prev, current: 1 }));
    }, 500);
    return () => clearTimeout(delay);
  }, [searchParams]);

  useEffect(() => {
    fetchRecords(searchParams, pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize, searchParams, fetchRecords]);

  useEffect(() => {
    if (Array.isArray(modesOfCourseState.data)) {
      setDataList(modesOfCourseState.data);
      setPagination((prev) => ({
        ...prev,
        total: modesOfCourseState.total || 0,
      }));
    }

  }, [modesOfCourseState.data]);

  const handlePagination = (newPagination: Pagination) => {
    setPagination(newPagination);
    fetchRecords(searchParams, newPagination.current, newPagination.pageSize);
  };

  const handleSearch = (value: string) => {
    setSearchParams((prev) => ({
      ...prev,
      query: value,
    }));
  };

  const getSerialNumber = (index: number) =>
    (pagination.current - 1) * pagination.pageSize + index + 1;

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      width: 90,
      render: (_: any, __: IModeOfCourse, index: number) => (
        <div>{getSerialNumber(index)}</div>
      ),
    },
    {
      title: "Mode of Course ID",
      dataIndex: "course_mode_id",
      width: 150,
    },
    {
      title: "Mode of Course Title",
      dataIndex: "course_mode_title",
      width: 200,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      width: 180,
      render: (created_at: string) => (
        <div>{formatDate(created_at)}</div>
      ),
    },
    {
      title: "Modified At",
      dataIndex: "modified_at",
      width: 180,
      render: (modified_at: string) => (
        <div>{formatDate(modified_at)}</div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Modes of Course Master</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Masters</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Modes of Course Master
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
            <h4 className="mb-4 mt-3">Modes of Course List</h4>
          </div>

          <div className="card-body p-0 py-3">
            <Table
              columns={columns}
              dataSource={dataList}
              Selection={false}
              paginationConfig={pagination}
              handlePagination={handlePagination}
              loading={modesOfCourseState.loading}
              handleSearch={handleSearch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModesOfCourseMaster;
